export default __webpack_public_path__ + "static/media/no-races.38ea991f.png";